import * as React from 'react';
import { Box, Button, Checkbox, HStack, Text, VStack } from 'native-base';
import { IRejectOption } from 'src/utils/rejectConfig';

interface RejectSelectionGroupProps {
  title: string;
  helperText?: string;
  options: IRejectOption[];
  selectedKeys: string[];
  onChange: (selectedKeys: string[]) => void;
}

export const RejectSelectionGroup: React.FC<RejectSelectionGroupProps> = ({
  title,
  helperText,
  options,
  selectedKeys,
  onChange,
}) => {
  const allSelected = options.length > 0 && selectedKeys.length === options.length;
  const selectedSet = React.useMemo(() => new Set(selectedKeys), [selectedKeys]);

  const toggleKey = (key: string, isChecked: boolean) => {
    if (isChecked) {
      onChange(Array.from(new Set([...selectedKeys, key])));
      return;
    }
    onChange(selectedKeys.filter((selectedKey) => selectedKey !== key));
  };

  return (
    <Box borderWidth={1} borderColor="coolGray.200" borderRadius="lg" p={4}>
      <VStack space={3}>
        <HStack justifyContent="space-between" alignItems="center">
          <VStack space={1} flex={1}>
            <Text fontSize="md" fontWeight="600">
              {title}
            </Text>
            {helperText ? (
              <Text fontSize="xs" color="coolGray.500">
                {helperText}
              </Text>
            ) : null}
          </VStack>
          {options.length > 0 ? (
            <Button
              size="xs"
              variant="ghost"
              onPress={() => onChange(allSelected ? [] : options.map((option) => option.key))}
            >
              {allSelected ? 'Clear all' : 'Select all'}
            </Button>
          ) : null}
        </HStack>

        <VStack space={2}>
          {options.length > 0 ? options.map((option) => (
            <Checkbox
              key={option.key}
              value={option.key}
              isChecked={selectedSet.has(option.key)}
              onChange={(value) => toggleKey(option.key, value)}
            >
              {option.label}
            </Checkbox>
          )) : (
            <Text fontSize="sm" color="coolGray.500">
              No reject parameters found for this grain.
            </Text>
          )}
        </VStack>
      </VStack>
    </Box>
  );
};
